import { memo } from 'react';
import './loader.scss';
import { KrakenGif, LoaderIcon } from '../icons/icons';

export interface LoaderProps {
    spinnerColor: string;
    loadingText: string;
    isKraken?: boolean;
    variant?: string;
}
const Loader = ({ spinnerColor, loadingText, isKraken = false, variant = 'loading-default' }: LoaderProps) => {

    return (
        <div className={variant}>
            {loadingText ? loadingText : 'Loading ... '}
            {isKraken ?
                <KrakenGif height={26} />
                :
                <LoaderIcon spinnerColor={spinnerColor} />
            }
        </div>
    );
};

export default memo(Loader);